import React, { useState, useRef, useEffect } from 'react'
import { UserSigner, parseUserKey } from '@multiversx/sdk-wallet'
import { toast } from 'react-toastify'

import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'

import SectionTitle from '../../../../components/kit/SectionTitle'
import { useAirdropDispatch } from '../../../../contexts/airDropContext'
import { storeSigner, storeInitiatorAddress } from '../../../../contexts/airdropActionCreators'
import UiButton from 'src/ui/atoms/Button'
import './PemModal.scss'

const PemModal = ({
  showPemModal,
  togglePemModal,
}: {
  showPemModal: boolean
  togglePemModal: () => void
}) => {
  const [file, setFile] = useState<any>(null)
  const [pemFileContent, setPemFileContent] = useState<string>('')

  const dispatchAirdropAction = useAirdropDispatch()

  const pemInputRef = useRef<any>(0)

  const handleFormSubmit = (e: any) => {
    e.preventDefault()
    // const keystoreFile = pemInputRef.current?.files?.[0];
    if (!file) {
      return
    }

    const reader = new FileReader()
    reader.onload = function (e: any) {
      if (e.target) {
        setPemFileContent(e.target.result)
      }
    }

    reader.readAsText(file)
  }

  const handleCloseModal = () => {
    togglePemModal()
    setFile(null)
    setPemFileContent('')
  }

  const loadSigner = () => {
    try {
      const signer = UserSigner.fromPem(pemFileContent)
      const secretKey = parseUserKey(pemFileContent)
      const publicKey = secretKey.generatePublicKey()
      const walletAddress = publicKey.toAddress()
      storeSigner(dispatchAirdropAction, signer)
      storeInitiatorAddress(dispatchAirdropAction, walletAddress.bech32())

      handleCloseModal()
    } catch (e) {
      console.error('error in creating signer', e)
      toast.error('Invalid private key')
    }
  }

  useEffect(() => {
    if (pemFileContent) {
      loadSigner()
    }
  }, [pemFileContent])

  const handleFileChange = (e: any) => {
    setFile(e.target.files[0])
  }

  return (
    <Modal
      open={showPemModal}
      onClose={handleCloseModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: '450px',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          py={3}
          px={2}
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '8px',
            boxSizing: 'border-box',
          }}>
          <form id="pemForm" className="PemForm" onSubmit={handleFormSubmit}>
            <SectionTitle title="Enter your wallet PEM file" />
            <Box
              mt={4}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                width: '100%',
              }}>
              <TextField
                inputProps={{
                  id: 'pemFile',
                  accept: '.pem',
                  ref: pemInputRef,
                  className: 'FileUploadInput',
                  onChange: handleFileChange,
                }}
                helperText="Drag and drop your PEM file here or click to select"
                type="file"
              />
            </Box>
            <Box
              mt={4}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
                width: '100%',
                gap: '40px',
              }}>
              <UiButton name="Cancel" size="M" onClick={handleCloseModal} type="secondary" />
              <Button
                className="btn btn-primary"
                color="success"
                size="medium"
                variant="contained"
                disabled={!file}
                type="submit">
                Connect
              </Button>
            </Box>
          </form>
        </Box>
      </Card>
    </Modal>
  )
}

export default PemModal
